export enum FeedbackQuestionEnum {
  LB_ShipperReuseCarrierQuestionId = 'LB_ShipperReuseCarrierQuestionId',
}
